var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    !_vm._.isEmpty(_vm.data.alias)
      ? _c(
          "span",
          {
            class: [
              _vm.data.obaobDstcd == _vm.$config.OBAOB_DSTCD_2 ? "name" : "stit"
            ]
          },
          [_vm._v(_vm._s(_vm.data.alias))]
        )
      : !_vm._.isNil(_vm.data.draweFname)
      ? _c(
          "span",
          {
            class: [
              _vm.data.obaobDstcd == _vm.$config.OBAOB_DSTCD_2 ? "name" : "stit"
            ]
          },
          [_vm._v(_vm._s(_vm.data.draweFname))]
        )
      : _vm._e(),
    _vm._v(
      " " +
        _vm._s(_vm.mnrcv == "latest" ? _vm.data.cupldAcno : _vm.data.acno) +
        " (" +
        _vm._s(_vm.mnrcv == "latest" ? _vm.data.cupldCncycd : _vm.data.cncycd) +
        ") "
    ),
    !_vm._.isNil(_vm.data.sysLastPrcssYMS)
      ? _c("span", { staticClass: "date" }, [
          _vm._v(_vm._s(_vm.$getGlobalDateYmd(_vm.data.sysLastPrcssYMS)))
        ])
      : _vm._e(),
    !_vm._.isNil(_vm.data.mrvamt)
      ? _c("div", { staticClass: "amount highlight" }, [
          _c("span", { staticClass: "exchange-unit" }, [
            _vm._v(_vm._s(_vm.data.cncycd))
          ]),
          _c("span", {
            staticClass: "total",
            domProps: {
              innerHTML: _vm._s(
                _vm.$num(
                  _vm.mnrcv == "latest" ? _vm.data.drwotAmt : _vm.data.mrvamt
                )
              )
            }
          })
        ])
      : _vm._e(),
    _vm.data.obaobDstcd == _vm.$config.OBAOB_DSTCD_2 &&
    !_vm._.isNil(_vm.data.othrBnkName)
      ? _c("span", { staticClass: "bank-name" }, [
          _vm._v(_vm._s(_vm.data.othrBnkName))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }